/* eslint-disable react-hooks/exhaustive-deps */
import { Area } from '@antv/g2plot';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useRef, useState } from 'react';
import Widget from '../../widget';
import { Style } from '../assessment-performance';
import { defaultData, mapData, Tooltip } from './helper';
import { getRange } from '../../../Modules/pme/screens/dashboard/widgets/mitigation-actions-trend/helper';
import DashboardPopover from '../../../../components/dashboards/components/Popover';

const metricsValues = [
  { color: "#FF4D4F", label: "Major Challenges", toggled: true, key: 'major' },
  { color: "#FFD591", label: "Moderate Challenges", toggled: true, key: 'moderate' },
  { color: "#FEF0C7", label: "Minor Challenges", toggled: true, key: 'minor' },
]

const ComplianceGaps = ({ data = defaultData, loading }) => {
  const { t } = useTranslation();
  const container = useRef();
  const [graph, setGraph] = useState(null);

  useEffect(() => {
    const _metricsValues = metricsValues.sort((a, b) => b.sort - a.sort);
    const _allData = Object.keys(data).reduce((all, key) => {
      const _obj = {};
      metricsValues.forEach((v) => {
        _obj[v.key] = data[key][v.key] || 0;
      });
      all[key] = _obj;
      return all;
    }, {});
    const mappedData = mapData(_allData, _metricsValues);
    const _data = mappedData.length ?
      [
        // { type: 'w0', value: 0, series: 'major' },
        // { type: 'w0', value: 0, series: 'minor' },
        // { type: 'w0', value: 0, series: 'moderate' },
        ...mappedData,
      ] : mappedData;

    if (data && metricsValues.length > 0) {
      const color = _metricsValues
        .filter((c) => c.toggled)
        .map((c) => c.color);


      if (!graph) {
        const area = new Area(container.current, {
          data: _data,
          xField: 'type',
          seriesField: 'series',
          yField: 'value',
          animation: false,
          color,
          legend: false,
          xAxis: {
            label: {
              formatter: () => '',
            },
            nice: true,
            tickLine: {
              style: {
                opacity: 0,
              }
            }
          },
          yAxis: {
            tickMethod: (a) => getRange(a.max),
          },
          tooltip: {
            customContent: (_, data) => {
              if (data[0]) {
                if (data[0]?.title === 'w0') {
                  return null;
                }

                if ((data[0].title || '_').indexOf('_') === -1) {
                  return Tooltip(data, t);
                }
              }
            },
          },
          point: {
            shape: 'round',
            size: 4,
            style: (a) => {
              const val = _metricsValues.find((m) => m.key === a.series);
              if (val) {
                const color = val.color;
                return {
                  fill: ((a.type || '_').indexOf('_') !== -1) ? 'transparent' : 'white',
                  stroke: ((a.type || '_').indexOf('_') !== -1) ? 'transparent' : color,
                  lineWidth: 2,
                };
              }
            },
          },
          areaStyle: {
            fillOpacity: 0.7,
          }
        });
        setGraph(area);
        area.render();
      } else {
        graph.update({
          data: _data,
          animation: false,
          color,
          point: {
            shape: 'round',
            size: 4,
            style: (a) => {
              const val = _metricsValues.find((m) => m.key === a.series);
              if (val) {
                const color = val.color;
                return {
                  fill: ((a.type || '_').indexOf('_') !== -1) ? 'transparent' : 'white',
                  stroke: ((a.type || '_').indexOf('_') !== -1) ? 'transparent' : color,
                  lineWidth: 2,
                };
              }
            },
          },
          areaStyle: {
            fillOpacity: 0.9,
          }
        });
      }
    }
  }, [data, metricsValues]);

  return (
    <Style>
      <Widget
        title={t('Active Challenges')}
        className="no-px-body"
        loading={loading}
        tooltip={(
          <DashboardPopover
            title={t('Open Challenges')}
            body={t('Evolution of challenges affecting the counterparty, as per list available in the Assessment Details')}
          />
        )}
      >
        <div className="chart-cont" ref={container} />
      </Widget>
    </Style>
  );
};

export default ComplianceGaps;
